export const PREFERENCES_DEFAULTS = {
	editorMode: 'visual',
	panels: {
		'post-status': {
			opened: true,
		},
	},
	features: {
		fixedToolbar: false,
		welcomeGuide: true,
		fullscreenMode: true,
	},
	hiddenBlockTypes: [],
	preferredStyleVariations: {},
	localAutosaveInterval: 15,
};
